import React, { useEffect, useState, createElement, Component } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { Star, Heart, MessageCircle, CheckCircle2, CreditCard, Users, Ticket, ChevronRight, X, Shield, Calendar, Infinity as InfinityIcon, Handshake, ChevronDown, HelpCircle, Camera } from 'lucide-react';
// --- Constants & Data ---
const BASIC_CHECKOUT_URL = 'https://hykxtx-bb.myshopify.com/cart/45146186350701:1';
const COMBO_CHECKOUT_URL = 'https://hykxtx-bb.myshopify.com/cart/45245472964717:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/kTMcgKJ2XWehvgBEEAMTwL/ChatGPT_Image_29_may_2026,_21_21_37.webp';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/hyRjcsCfC9oubUGBy62xij/sacame_el_titulo_202604231454.jpg';
const PROJECTS = [{
  url: 'https://cdn.magicpatterns.com/uploads/vJAdAU9F55Mj2ancFfSAnt/ChatGPT_Image_11_may_2026,_19_54_50.webp',
  title: 'Top Rayado Azul',
  comment: '¡Un diseño fresco y moderno que todas quieren tener!'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/aQwuvqMdppPvopx5rooSeV/Gemini_Generated_Image_gn180ign180ign18.png',
  title: 'Manta de Grannys',
  comment: 'Un clásico que nunca falla, llena de color y calidez.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ksU5Uo7dQMpiGrGZcccnaz/Prompt_idea___Hiperrealista_202604241423_(1).jpg',
  title: 'Almohadón Decorativo',
  comment: 'Texturas que enamoran y transforman cualquier espacio.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3pK23SqLvuAhaaVbd4fqQr/Prompt_idea___Hiperrealista_202604241423.jpg',
  title: 'Bolso Playero Multicolor',
  comment: 'Resistente, alegre y con un acabado profesional increíble.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/pFgXee8bRZbkdaMAsPtN8G/_Hiperrealista_primer_plano_202604241413.jpg',
  title: 'Set de Bebé Natural',
  comment: 'Pura ternura en cada punto, el regalo más especial.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/uH3dmvb5P6WdGkd9z8zA5U/e281a48123fedb0da68a28313ae11b4d.jpg',
  title: 'Llavero Conejito',
  comment: 'Un detalle adorable y rápido de tejer para regalar.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/71NrGNGwRTowLrqdN1dyBx/Gemini_Generated_Image_do8gq5do8gq5do8g_(1).png',
  title: 'Bolso Matero Verde',
  comment: 'Elegancia y funcionalidad en un diseño de punto fantasía.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/9z426dRo3ZX8qnCZcw7LeR/_Hiperrealista_primer_plano_202604241402.jpg',
  title: 'Top de Grannys Lavanda',
  comment: 'La tendencia boho-chic llevada a su máxima expresión.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ggBZ6EgGjVihSEnfBUa6B5/quiero_que_el_202604241355.jpg',
  title: 'Tote Bag Minimalista',
  comment: 'Simple, sofisticado y perfecto para el uso diario.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8UabECVL5irwKebE7HAPH4/quiero_que_me_202604241250.jpg',
  title: 'Ramo de Flores Eternas',
  comment: 'Un jardín que nunca marchita, tejido con puro amor.'
}];
const BONUSES = [{
  id: 1,
  title: 'BONO #1 - LA ESENCIA DEL TEJIDO',
  desc: 'Los secretos técnicos para que tus acabados sean perfectos y profesionales, eliminando esos pequeños errores que delatan a una principiante.',
  img: 'https://cdn.magicpatterns.com/uploads/hetHGg8n8S3h3i214rpLof/bono1.webp'
}, {
  id: 2,
  title: 'BONO #2 - DULCE COMPAÑÍA',
  desc: 'La colección especializada en amigurumis y muñecos. El regalo perfecto para tus nietos o el producto más vendido si decidís emprender.',
  img: 'https://cdn.magicpatterns.com/uploads/sHfVLJvHFBNv9aF73zBtjZ/bono2.webp'
}, {
  id: 3,
  title: 'BONO #3 - FLORECER EN HILOS',
  desc: 'Guía paso a paso para crear flores tridimensionales que transformarán cualquier prenda básica en una pieza de diseño única.',
  img: 'https://cdn.magicpatterns.com/uploads/f9NZXMXbHdh7hBDSv7aULR/bono3.webp'
}, {
  id: 4,
  title: 'BONO #4 - TRAMAS QUE ACOMPAÑAN',
  desc: 'Diseños de mantas y bolsos de gran formato, ideales para decorar tu hogar o hacer los regalos más inolvidables de tu círculo social.',
  img: 'https://cdn.magicpatterns.com/uploads/j1VTZQYK1FdX2aRr2wJkmw/agregame_por_ahi_202604231713.webp'
}, {
  id: 5,
  title: 'BONO #5 - MODA CON ALMA',
  desc: 'Aprendé a tejer ropa que realmente quede bien. Blusas, cardigans y accesorios con estilo contemporáneo y elegante.',
  img: 'https://cdn.magicpatterns.com/uploads/hG2p27rgETTkkhYhiZdwtW/bono5.webp'
}];
const TESTIMONIALS = [{
  name: 'Marta G.',
  text: 'che no puedo creer lo q estoy viendo, los patrones son re claros. antes me volvia loca con los de youtube q no se entendia nada. mil gracias!',
  rating: 5
}, {
  name: 'Silvia de Cordoba',
  text: 'lo compre ayer y ya termine un amigurumi para mi nieta. quedo divino mal. valio cada peso.',
  rating: 5
}, {
  name: 'Graciela',
  text: 'al principio dudaba x el precio pero la verdad q la calidad es otra cosa. se nota q saben lo q hacen.',
  rating: 4
}, {
  name: 'Mirta R.',
  text: 'estaba cansada de desarmar todo el tiempo. con hilos que enamoran por fin me sale todo de una. re contenta!',
  rating: 5
}, {
  name: 'Elena',
  text: 'muy bueno todo, los bonos son geniales. el de las flores me encanto.',
  rating: 5
}];
const ARG_CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
const NAMES = ['Maria', 'Ana', 'Juana', 'Beatriz', 'Graciela', 'Marta', 'Silvia', 'Elena', 'Patricia', 'Rosa'];
const UpsellSection = ({
  onPurchase
}: {
  onPurchase: (plan: string) => void;
}) => {
  const [selected, setSelected] = useState<'alma' | 'combo'>('combo');
  const options = {
    alma: {
      title: 'Hilos que Enamoran',
      price: '$19.990',
      oldPrice: '$39.990',
      img: 'https://cdn.magicpatterns.com/uploads/hrQgKd5UJCpN5dWX19WRQu/ChatGPT_Image_27_abr_2026,_13_26_57.png',
      includes: ['Acceso Hilos que Enamoran', 'Bono #1: La Esencia del Tejido', 'Bono #2: Dulce Compañía (Amigurumis)', 'Bono #3: Florecer en Hilos (Flores 3D)', 'Bono #4: Tramas que Acompañan (Mantas)', 'Bono #5: Moda con Alma (Prendas)', 'Acceso Vitalicio al Contenido']
    },
    combo: {
      title: 'Hilos + Alma Textil',
      price: '$29.990',
      oldPrice: '$59.990',
      label: 'OFERTA COMPLETA',
      popular: true,
      img: 'https://cdn.magicpatterns.com/uploads/dYQp3DYJKGXKzbWoyQi5F6/ChatGPT_Image_28_may_2026,_11_04_32.webp',
      includes: ['Acceso a Hilos que Enamoran + Alma Textil', 'Acceso a los 5 bonos de hilos que enamoran', 'Bono #1: Atelier de Creación', 'Bono #2: Hogar con Alma', 'Bono #3: Tu Marca Textil', 'Bono #4: Costura desde Cero', 'Acceso Vitalicio a AMBOS Cursos']
    }
  };
  return <div className="upsell-box checkout-container checkout-wrapper product-checkout offer-container cart-container checkout-section w-[96%] max-w-[520px] md:max-w-[1200px] mx-auto mt-4 mb-8 p-6 md:p-8 px-[18px] md:px-8 bg-[#fff7f3] rounded-[3rem] border border-[#ead7cf] shadow-sm flex flex-col md:flex-row gap-10 md:gap-16 items-center" data-id="element-0">
      {/* Left side: Image Preview */}
      <div className="upsell-image-box upsell-preview selected-upsell-image w-full md:w-[60%] text-center overflow-hidden rounded-3xl border border-[#ead7cf]/50 bg-white p-3 shrink-0 shadow-lg" data-id="element-1">
        <AnimatePresence mode="wait" data-id="element-2">
          <motion.img id="upsell-image" key={selected} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 1.05
        }} transition={{
          duration: 0.3
        }} src={options[selected].img} alt="Oferta seleccionada" className="w-full h-auto rounded-[18px] shadow-inner block" data-id="element-3" />
        </AnimatePresence>
      </div>

      {/* Right side: Selection and Purchase */}
      <div className="w-full md:w-[40%] flex flex-col" data-id="element-4">
        <h3 className="mb-6 text-2xl font-bold text-[#4b342c] font-serif" data-id="element-5">
          Elegí tu oferta especial
        </h3>

        <div className="upsell-cards grid grid-cols-2 gap-3 mb-6 w-full" data-id="element-6">
          {/* Card Alma */}
          <div onClick={() => setSelected('alma')} className={`upsell-card relative border-2 rounded-2xl bg-white cursor-pointer transition-all duration-300 flex flex-col p-4 ${selected === 'alma' ? 'border-[#b87959] shadow-lg -translate-y-1 bg-[#fffaf8]' : 'border-[#ead7cf] opacity-80 hover:opacity-100'}`} data-id="element-7">
            <div className="flex items-center justify-between mb-2" data-id="element-8">
              <span className="text-[10px] font-bold text-[#9b5c3c] uppercase tracking-wider" data-id="element-9">
                Básico
              </span>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'alma' ? 'border-[#b87959] bg-[#b87959]' : 'border-[#ead7cf]'}`} data-id="element-10">
                {selected === 'alma' && <CheckCircle2 className="w-3.5 h-3.5 text-white" data-id="element-11" />}
              </div>
            </div>
            <h4 className="text-sm md:text-base font-bold text-[#4b342c] mb-2" data-id="element-12">
              {options.alma.title}
            </h4>
            <div className="flex flex-col mb-3" data-id="element-13">
              <span className="text-xs line-through opacity-70 font-medium text-[#B41911]" data-id="element-14">
                {options.alma.oldPrice}
              </span>
              <strong className="text-xl md:text-2xl font-black text-[#b87959]" data-id="element-15">
                {options.alma.price}
              </strong>
            </div>
            <div className="mt-auto" data-id="element-16">
              <div className={`${`w-full py-2 rounded-xl text-center text-[10px] font-black uppercase tracking-wider transition-all ${selected === 'alma' ? 'bg-[#b87959] text-white shadow-sm' : 'bg-[#ead7cf]/20 text-[#9b5c3c] border border-[#ead7cf]/50'}`} bg-[#D27B4F]`} data-id="element-17">
                {selected === 'alma' ? '✓ SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </div>

          {/* Card Combo */}
          <div onClick={() => setSelected('combo')} className={`upsell-card relative border-2 rounded-2xl bg-white cursor-pointer transition-all duration-300 flex flex-col p-4 ${selected === 'combo' ? 'border-[#b87959] shadow-lg -translate-y-1 bg-[#fffaf8]' : 'border-[#ead7cf] opacity-80 hover:opacity-100'}`} data-id="element-18">
            {options.combo.popular && <div className="absolute -top-3 right-4 bg-[#FFD700] text-[#4b342c] px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-tighter shadow-md z-10 border border-[#DAA520]/30" data-id="element-19">
                ★ MÁS PEDIDO
              </div>}
            <div className="flex items-center justify-between mb-2" data-id="element-20">
              <span className="text-[10px] font-bold text-[#9b5c3c] uppercase tracking-wider" data-id="element-21">
                {options.combo.label}
              </span>
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-[#b87959] bg-[#b87959]' : 'border-[#ead7cf]'}`} data-id="element-22">
                {selected === 'combo' && <CheckCircle2 className="w-3.5 h-3.5 text-white" data-id="element-23" />}
              </div>
            </div>
            <h4 className="text-sm md:text-base font-bold text-[#4b342c] mb-2" data-id="element-24">
              {options.combo.title}
            </h4>
            <div className="flex flex-col mb-3" data-id="element-25">
              <span className="text-xs line-through opacity-70 font-medium text-[#A70500]" data-id="element-26">
                {options.combo.oldPrice}
              </span>
              <strong className="text-xl md:text-2xl font-black text-[#b87959]" data-id="element-27">
                {options.combo.price}
              </strong>
            </div>
            <div className="mt-auto" data-id="element-28">
              <div className={`${`w-full py-2 rounded-xl text-center text-[10px] font-black uppercase tracking-wider transition-all ${selected === 'combo' ? 'bg-[#b87959] text-white shadow-sm' : 'bg-[#ead7cf]/20 text-[#9b5c3c] border border-[#ead7cf]/50'}`} bg-[#B7702A]`} data-id="element-29">
                {selected === 'combo' ? '✓ SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </div>
        </div>

        {/* Inclusion Details */}
        <div className="mb-10 bg-white/60 rounded-[2rem] p-6 md:p-8 border border-[#ead7cf]/50 shadow-inner" data-id="element-30">
          <p className="text-xs font-bold text-[#9b5c3c] uppercase tracking-widest mb-5" data-id="element-31">
            ¿Qué incluye tu acceso inmediato?
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-32">
            <AnimatePresence mode="wait" data-id="element-33">
              <motion.div key={selected} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 10
            }} transition={{
              duration: 0.2
            }} className="contents" data-id="element-34">
                {options[selected].includes.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-xs text-[#6d5a52]" data-id="element-35">
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#32B742] shrink-0 mt-0.5" data-id="element-36" />
                    <span data-id="element-37">{item}</span>
                  </li>)}
              </motion.div>
            </AnimatePresence>
          </ul>
        </div>

        <div className="flex flex-col items-center mb-4" data-id="element-38">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          repeat: Infinity,
          repeatType: 'reverse',
          duration: 0.8
        }} className="bg-[#E07A5F] text-white text-[10px] font-black px-3 py-1 rounded-full shadow-sm mb-2 uppercase tracking-tighter" data-id="element-39">
            🔥 ¡ÚLTIMA OPORTUNIDAD! 50% OFF 🔥
          </motion.div>
          <button onClick={() => onPurchase(selected)} className="w-full bg-[#32B742] hover:bg-[#28a736] text-white font-black py-6 md:py-8 rounded-[2rem] shadow-2xl transition-all active:scale-[0.98] animate-slow-pulse flex mb-[0px] gap-[4px] flex-col items-center justify-center pt-[25px] pb-[25px]" data-id="element-40">
            <span className="text-xl md:text-2xl uppercase tracking-wider" data-id="element-41">
              ACCEDER AHORA
            </span>
          </button>
          <p className="mt-3 text-[11px] font-bold text-[#32B742] uppercase tracking-widest flex items-center gap-1.5" data-id="element-42">
            <CreditCard className="w-3 h-3" data-id="element-43" /> 3 cuotas sin interés
          </p>
        </div>

        {/* Trust Badges & Payment Methods */}
        <div className="mt-8 flex flex-col items-center gap-8" data-id="element-44">
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10" data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/neGXZrkHvNNYaCXDbmKomJ/Helado-Artesanal-1.webp" alt="Pago Seguro Garantizado" className="h-20 md:h-32 w-auto object-contain" data-id="element-46" />
            <img src="https://cdn.magicpatterns.com/uploads/pgzVJbdiRPLpCU4NGeT7ja/safe-purchase-7779878_1280.webp" alt="Compra Segura" className="h-16 md:h-24 w-auto object-contain" data-id="element-47" />
            <img src="https://cdn.magicpatterns.com/uploads/dDhh8BNUSkhYChFDuk7BGJ/MercadoLider-en-Mercado-Libre.webp" alt="MercadoLíder Platinum" className="h-16 md:h-24 w-auto object-contain" data-id="element-48" />
          </div>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10" data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/qi2oY9qsj5w8gdrBUbdF8B/pago_mercado_libre.webp" alt="Mercado Pago" className="h-14 md:h-20 w-auto object-contain" data-id="element-50" />
            <img src="https://cdn.magicpatterns.com/uploads/8m48J8wFUWxS6uSwCxZMFM/zn9vtwfya.webp" alt="7 Días de Garantía" className="h-24 md:h-36 w-auto object-contain" data-id="element-51" />
          </div>
        </div>
      </div>
    </div>;
};
// --- Countdown Timer Component ---
const CountdownTimer = ({
  showDate = false
}: {
  showDate?: boolean;
}) => {
  const [timeLeft, setTimeLeft] = useState<{
    minutes: number;
    seconds: number;
  } | null>(null);
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long'
  }).toUpperCase();
  useEffect(() => {
    const STORAGE_KEY = 'hilos_enamoran_timer_end';
    const FIFTEEN_MINUTES = 15 * 60 * 1000;
    const getEndTime = () => {
      let stored = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();
      if (!stored || isNaN(parseInt(stored)) || now > parseInt(stored)) {
        const newEnd = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, newEnd.toString());
        return newEnd;
      }
      return parseInt(stored);
    };
    let endTime = getEndTime();
    const updateTimer = () => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        endTime = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, endTime.toString());
      }
      const minutes = Math.floor(Math.max(0, difference) / 1000 / 60 % 60);
      const seconds = Math.floor(Math.max(0, difference) / 1000 % 60);
      setTimeLeft({
        minutes,
        seconds
      });
    };
    // Initial call
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!timeLeft) return null;
  const timeStr = `${timeLeft.minutes.toString().padStart(2, '0')}:${timeLeft.seconds.toString().padStart(2, '0')}`;
  if (showDate) {
    return <span data-id="element-52">
        {today} OFERTA · {timeStr}
      </span>;
  }
  return <div className="flex items-center gap-1 ml-[22px] pl-[22px] pr-[22px] mr-[30px]" data-id="element-53">
      <span className="text-sm font-black tabular-nums text-[#2F5233] pl-[2px] pr-[2px]" data-id="element-54">
        {timeStr}
      </span>
    </div>;
};
// --- Custom Icons ---
const YarnBallIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-55">
    <circle cx="12" cy="12" r="10" data-id="element-56" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10" data-id="element-57" />
    <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10" data-id="element-58" />
    <path d="M2 12h20" data-id="element-59" />
    <path d="M12 2v20" data-id="element-60" />
    <path d="M7 7l10 10" data-id="element-61" />
    <path d="M7 17L17 7" data-id="element-62" />
  </svg>;
// --- Components ---
const StickyHeader = ({
  onAction,
  purchaseMsg
}: {
  onAction: () => void;
  purchaseMsg: string | null;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    if (latest > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  });
  return <AnimatePresence data-id="element-63">
      {isVisible && <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 left-0 right-0 z-[100] bg-white/80 backdrop-blur-md border-b border-[#2F5233]/10 shadow-lg floating-bar" data-id="element-64">
          <div className="floating-counter text-[#2F5233]" data-id="element-65">
            <AnimatePresence mode="wait" data-id="element-66">
              {purchaseMsg ? <motion.div key="msg" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} className="floating-purchase-message" data-id="element-67">
                  {purchaseMsg}
                </motion.div> : <motion.div key="timer" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} data-id="element-68">
                  <CountdownTimer showDate data-id="element-69" />
                </motion.div>}
            </AnimatePresence>
          </div>

          <button onClick={onAction} className="bg-[#E07A5F] text-white px-6 py-2.5 rounded-full font-black uppercase shadow-md hover:bg-[#D1694E] transition-all active:scale-95 text-[12px] offer-button" data-id="element-70">
            VER OFERTA
          </button>
        </motion.div>}
    </AnimatePresence>;
};
const ScrollReveal = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 40
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 1.2,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} data-id="element-71">
    {children}
  </motion.div>;
const CommentSection = () => {
  const AVATAR_COLORS = ['from-[#2F5233] to-[#4A7856]', 'from-[#E07A5F] to-[#D1694E]', 'from-[#9FD9D3] to-[#6BC4B8]', 'from-[#8D7B6D] to-[#A69484]', 'from-[#D4AF37] to-[#C49B2A]', 'from-[#B56576] to-[#9E4F5E]', 'from-[#6D597A] to-[#5B4868]', 'from-[#355070] to-[#2A4059]'];
  const AVATAR_EMOJIS = ['🧶', '🪡', '🧵', '🌸', '🌿', '💐', '🎀', '🦋', '🌻', '🐰', '🧸', '✨', '💜', '🌺', '🍀', '🎨', '🪻', '🐱', '🌷', '🫧'];
  const [comments, setComments] = useState([{
    id: 1,
    user: 'Norma Beatriz',
    avatar: 'NB',
    emoji: '🧶',
    colorIdx: 0,
    date: 'hace 2 horas',
    rating: 5,
    text: 'Increíble la calidad de los gráficos, tanto para crochet como para dos agujas. Por fin entiendo cómo cerrar bien los puntos. ¡Muy recomendado!',
    likes: 24,
    isLiked: false
  }, {
    id: 2,
    user: 'Graciela M.',
    avatar: 'GM',
    emoji: '🪡',
    colorIdx: 1,
    date: 'hace 4 horas',
    rating: 5,
    text: 'Los amigurumis son un sueño. Ya terminé mi primer muñeco para mi nieta y quedó precioso.',
    likes: 18,
    isLiked: false
  }, {
    id: 3,
    user: 'Marta Silvia',
    avatar: 'MS',
    emoji: '🌸',
    colorIdx: 2,
    date: 'hace 5 horas',
    rating: 4,
    text: 'Muy completo todo. Me gustaría que suban más de ropa de invierno, pero el set de bebé es precioso.',
    likes: 12,
    isLiked: false
  }, {
    id: 4,
    user: 'Elena R.',
    avatar: 'ER',
    emoji: '🧵',
    colorIdx: 3,
    date: 'hace 1 día',
    rating: 5,
    text: 'Los patrones son muy claros, valió la pena la inversión. Ya estoy empezando el tercer proyecto.',
    likes: 9,
    isLiked: false
  }, {
    id: 5,
    user: 'Patricia G.',
    avatar: 'PG',
    emoji: '🌿',
    colorIdx: 4,
    date: 'hace 1 día',
    rating: 5,
    text: 'Excelente atención y los archivos llegan al toque. Los diseños son muy originales.',
    likes: 15,
    isLiked: false
  }, {
    id: 6,
    user: 'Rosa Inés',
    avatar: 'RI',
    emoji: '💐',
    colorIdx: 5,
    date: 'hace 2 días',
    rating: 4,
    text: 'Me encantaron los bonos, especialmente el de las flores. Muy bien explicado todo.',
    likes: 7,
    isLiked: false
  }, {
    id: 7,
    user: 'Mirta Beatriz',
    avatar: 'MB',
    emoji: '🎀',
    colorIdx: 6,
    date: 'hace 2 días',
    rating: 5,
    text: 'Por fin encontré patrones que se entienden de verdad. ¡Gracias por compartir su talento!',
    likes: 21,
    isLiked: false
  }, {
    id: 8,
    user: 'Alicia S.',
    avatar: 'AS',
    emoji: '🦋',
    colorIdx: 7,
    date: 'hace 3 días',
    rating: 5,
    text: 'El grupo de apoyo es genial. Siempre hay alguien para sacarte las dudas.',
    likes: 11,
    isLiked: false
  }, {
    id: 9,
    user: 'Susana T.',
    avatar: 'ST',
    emoji: '🌻',
    colorIdx: 0,
    date: 'hace 3 días',
    rating: 5,
    text: 'La biblioteca es inmensa, hay para todos los gustos. Muy conforme con la compra.',
    likes: 14,
    isLiked: false
  }, {
    id: 10,
    user: 'Gladys R.',
    avatar: 'GR',
    emoji: '🐰',
    colorIdx: 1,
    date: 'hace 4 días',
    rating: 5,
    text: 'Ya hice tres mantas para regalar. Los puntos fantasía son hermosos.',
    likes: 19,
    isLiked: false
  }, {
    id: 11,
    user: 'Juana P.',
    avatar: 'JP',
    emoji: '🧸',
    colorIdx: 2,
    date: 'hace 4 días',
    rating: 4,
    text: 'Muy buenos los videos explicativos que vienen de regalo. Ayudan mucho.',
    likes: 8,
    isLiked: false
  }, {
    id: 12,
    user: 'Beatriz L.',
    avatar: 'BL',
    emoji: '✨',
    colorIdx: 3,
    date: 'hace 5 días',
    rating: 5,
    text: 'Es la mejor inversión que hice este año para mi hobby. ¡Sigan así!',
    likes: 25,
    isLiked: false
  }, {
    id: 13,
    user: 'Silvia N.',
    avatar: 'SN',
    emoji: '💜',
    colorIdx: 4,
    date: 'hace 5 días',
    rating: 5,
    text: 'Los patrones de ropa son tendencia total. Me hice un cárdigan que todos me elogian.',
    likes: 16,
    isLiked: false
  }, {
    id: 14,
    user: 'Margarita F.',
    avatar: 'MF',
    emoji: '🌺',
    colorIdx: 5,
    date: 'hace 6 días',
    rating: 5,
    text: 'Todo perfecto, desde el pago hasta la descarga. Muy profesionales.',
    likes: 13,
    isLiked: false
  }, {
    id: 15,
    user: 'Cristina D.',
    avatar: 'CD',
    emoji: '🍀',
    colorIdx: 6,
    date: 'hace 6 días',
    rating: 5,
    text: 'Me encanta que los patrones vengan con gráficos claros. Facilita mucho el trabajo.',
    likes: 17,
    isLiked: false
  }, {
    id: 16,
    user: 'Zulma T.',
    avatar: 'ZT',
    emoji: '🎨',
    colorIdx: 7,
    date: 'hace 1 semana',
    rating: 4,
    text: 'Muy lindo todo. El set de cocina es lo más vendido en mi emprendimiento.',
    likes: 10,
    isLiked: false
  }, {
    id: 17,
    user: 'Olga B.',
    avatar: 'OB',
    emoji: '🪻',
    colorIdx: 0,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Gracias por los consejos para principiantes. Me ayudaron a perder el miedo.',
    likes: 22,
    isLiked: false
  }, {
    id: 18,
    user: 'Nélida G.',
    avatar: 'NG',
    emoji: '🐱',
    colorIdx: 1,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Los amigurumis de animales son los más tiernos que vi. ¡Mis nietos están felices!',
    likes: 20,
    isLiked: false
  }, {
    id: 19,
    user: 'Inés S.',
    avatar: 'IS',
    emoji: '🌷',
    colorIdx: 2,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Excelente material. Se nota que hay mucho trabajo detrás de cada patrón.',
    likes: 18,
    isLiked: false
  }, {
    id: 20,
    user: 'Raquel M.',
    avatar: 'RM',
    emoji: '🫧',
    colorIdx: 3,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Súper completo. No me canso de descubrir nuevos proyectos para hacer.',
    likes: 23,
    isLiked: false
  }]);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(5);
  const [showThanks, setShowThanks] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (!newComment.trim()) return;
    const randomIdx = Math.floor(Math.random() * AVATAR_EMOJIS.length);
    const comment = {
      id: Date.now(),
      user: 'Usuario',
      avatar: 'U',
      emoji: AVATAR_EMOJIS[randomIdx],
      colorIdx: randomIdx % AVATAR_COLORS.length,
      date: 'ahora mismo',
      rating,
      text: newComment,
      likes: 0,
      isLiked: false
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setRating(5);
    setShowThanks(true);
  };
  const toggleLike = (id: number) => {
    setComments(comments.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  return <ScrollReveal data-id="element-72">
      <div className="max-w-4xl mx-auto p-8 bg-white/40 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10 shadow-sm pt-[32px] pb-[32px] mt-[40px] space-y-[24px]" data-id="element-73">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-10 gap-4" data-id="element-74">
          <h3 className="text-3xl font-bold flex items-center gap-3 text-[#2F5233] font-serif" data-id="element-75">
            <MessageCircle className="text-[#E07A5F] w-8 h-8" data-id="element-76" /> Comunidad y
            Feedback
          </h3>
          <div className="flex items-center gap-2 bg-[#2F5233]/5 px-4 py-2 rounded-full border border-[#2F5233]/10" data-id="element-77">
            <div className="flex gap-0.5" data-id="element-78">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" data-id="element-79" />)}
            </div>
            <span className="text-sm font-bold text-[#2F5233]" data-id="element-80">
              4.9/5 Promedio
            </span>
          </div>
        </div>

        <div className="mb-12 space-y-6 bg-white/60 p-8 rounded-[2.5rem] border border-[#2F5233]/5 shadow-inner" data-id="element-81">
          <div className="flex flex-col gap-4" data-id="element-82">
            <p className="text-sm font-bold text-[#8D7B6D] uppercase tracking-wider" data-id="element-83">
              Tu Calificación:
            </p>
            <div className="flex gap-2" data-id="element-84">
              {[1, 2, 3, 4, 5].map(s => <motion.button key={s} whileHover={{
              scale: 1.2
            }} whileTap={{
              scale: 0.9
            }} onClick={() => setRating(s)} data-id="element-85">
                  <Star className={`w-8 h-8 transition-colors ${s <= rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-86" />
                </motion.button>)}
            </div>
          </div>

          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Compartí tu experiencia con la comunidad..." className="w-full bg-white border border-[#2F5233]/10 rounded-2xl p-5 text-[#4A3F35] focus:ring-2 focus:ring-[#2F5233]/20 outline-none transition-all shadow-sm min-h-[120px]" data-id="element-87" />

          <div className="flex flex-wrap items-center justify-end gap-4" data-id="element-88">
            <button onClick={handlePublish} disabled={!newComment.trim()} className="bg-[#2F5233] text-white font-black py-4 px-10 rounded-2xl hover:bg-[#1F3A22] transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed active:scale-95" data-id="element-89">
              Publicar Comentario
            </button>
          </div>
        </div>

        <div className="space-y-4" data-id="element-90">
          <AnimatePresence mode="popLayout" data-id="element-91">
            {comments.slice(0, visibleCount).map(c => <motion.div key={c.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-white/40 p-4 rounded-2xl border border-[#2F5233]/5 hover:border-[#2F5233]/10 transition-all group" data-id="element-92">
                <div className="flex gap-4" data-id="element-93">
                  <div className={`w-12 h-12 shrink-0 rounded-full flex items-center justify-center shadow-sm border border-white/50 bg-gradient-to-br ${AVATAR_COLORS[c.colorIdx % AVATAR_COLORS.length]}`} data-id="element-94">
                    <span className="text-xl" data-id="element-95">{c.emoji}</span>
                  </div>
                  <div className="flex-1 flex flex-col" data-id="element-96">
                    <div className="flex items-center justify-between mb-2" data-id="element-97">
                      <div className="flex items-center gap-2" data-id="element-98">
                        <div data-id="element-99">
                          <p className="font-bold text-[#2F5233] leading-none text-sm mb-1" data-id="element-100">
                            {c.user}
                          </p>
                          <div className="flex items-center gap-2" data-id="element-101">
                            <div className="flex gap-0.5" data-id="element-102">
                              {Array.from({
                            length: 5
                          }).map((_, i) => <Star key={i} className={`w-2.5 h-2.5 ${i < c.rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-103" />)}
                            </div>
                            <span className="text-[9px] text-[#8D7B6D] font-medium" data-id="element-104">
                              • {c.date}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#2F5233]/5 px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-105">
                        <CheckCircle2 className="w-2.5 h-2.5 text-[#2F5233]" data-id="element-106" />
                        <span className="text-[8px] font-bold text-[#2F5233] uppercase" data-id="element-107">
                          Verificada
                        </span>
                      </div>
                    </div>
                    <p className="text-[#4A3F35] text-sm leading-relaxed mb-3 flex-1 italic" data-id="element-108">
                      "{c.text}"
                    </p>
                    <div className="flex items-center justify-between pt-2 border-t border-[#2F5233]/5" data-id="element-109">
                      <button onClick={() => toggleLike(c.id)} className={`flex items-center gap-1.5 px-3 py-1 rounded-full transition-all font-bold text-[11px] ${c.isLiked ? 'bg-[#E07A5F]/10 text-[#E07A5F]' : 'text-[#8D7B6D] hover:bg-[#2F5233]/5'}`} data-id="element-110">
                        <Heart className={`w-3.5 h-3.5 transition-all ${c.isLiked ? 'fill-[#E07A5F]' : ''}`} data-id="element-111" />
                        {c.likes}
                      </button>
                      <button className="text-[10px] font-bold text-[#2F5233]/40 hover:text-[#2F5233] transition-colors" data-id="element-112">
                        Responder
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {visibleCount < comments.length && <button onClick={() => setVisibleCount(prev => prev + 3)} className="w-full mt-10 py-5 border-2 border-dashed border-[#2F5233]/10 rounded-[2rem] font-black text-[#2F5233] hover:bg-[#2F5233]/5 hover:border-[#2F5233]/20 transition-all uppercase tracking-widest text-sm" data-id="element-113">
            Ver más testimonios de la comunidad
          </button>}

        {showThanks && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/20 backdrop-blur-md p-4" data-id="element-114">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white text-[#4A3F35] p-10 rounded-[3rem] max-w-sm text-center shadow-2xl border border-[#2F5233]/10" data-id="element-115">
              <div className="bg-[#2F5233]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-116">
                <CheckCircle2 className="text-[#2F5233] w-12 h-12" data-id="element-117" />
              </div>
              <h4 className="text-2xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-118">
                ¡Gracias por inspirarnos!
              </h4>
              <p className="text-[#8D7B6D] mb-8 leading-relaxed" data-id="element-119">
                Tu proyecto y tu opinión son el motor de esta comunidad.
              </p>
              <button onClick={() => setShowThanks(false)} className="w-full bg-[#2F5233] text-white py-4 rounded-2xl font-black shadow-lg hover:bg-[#1F3A22] transition-colors uppercase tracking-wider" data-id="element-120">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </div>
    </ScrollReveal>;
};
const ProjectCarousel = () => {
  return <div className="w-full overflow-hidden py-12 bg-[#2F5233]/5 rounded-[3rem] border border-[#2F5233]/10" data-id="element-121">
      <div className="text-center mb-10" data-id="element-122">
        <h3 className="text-3xl font-bold text-[#2F5233] font-serif" data-id="element-123">
          Proyectos Terminados por la Comunidad
        </h3>
        <p className="text-[#8D7B6D]" data-id="element-124">
          Inspirate con lo que vos también vas a lograr
        </p>
      </div>

      <div className="flex relative" data-id="element-125">
        <motion.div className="flex gap-6 px-6" animate={{
        x: [0, -2500]
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-126">
          {[...PROJECTS, ...PROJECTS].map((project, idx) => <div key={idx} className="min-w-[300px] bg-white rounded-3xl overflow-hidden shadow-md border border-[#2F5233]/5 group" data-id="element-127">
              <div className="h-64 overflow-hidden" data-id="element-128">
                <img src={project.url} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-129" />
              </div>
              <div className="p-6" data-id="element-130">
                <h4 className="font-bold text-[#2F5233] mb-2" data-id="element-131">
                  {project.title}
                </h4>
                <p className="text-sm text-[#8D7B6D] italic" data-id="element-132">
                  "{project.comment}"
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#2F5233]/10 last:border-0" data-id="element-133">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left gap-4 group" data-id="element-134">
        <div className="flex items-center gap-4" data-id="element-135">
          <div className="w-10 h-10 rounded-full bg-[#2F5233]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2F5233]/10 transition-colors" data-id="element-136">
            <HelpCircle className="w-5 h-5 text-[#E07A5F]" data-id="element-137" />
          </div>
          <span className="text-lg font-bold text-[#2F5233] font-serif" data-id="element-138">
            {question}
          </span>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-139">
          <ChevronDown className="w-6 h-6 text-[#8D7B6D] mb-[80px]" data-id="element-140" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-141">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-142">
            <p className="pb-6 pl-14 text-[#8D7B6D] leading-relaxed" data-id="element-143">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FAQSection = () => {
  const faqs = [{
    question: '¿Cómo recibo mi biblioteca de patrones?',
    answer: 'La entrega es inmediata y digital. Una vez confirmado tu pago, recibirás un correo electrónico con el acceso para descargar toda la biblioteca completa en formato PDF. Podrás verlos en tu celular, tablet o computadora.'
  }, {
    question: '¿Por cuánto tiempo tendré acceso a los patrones?',
    answer: '¡El acceso es de por vida! Una vez que realizás la compra, los patrones son tuyos para siempre. Podés descargarlos las veces que necesites y guardarlos en tus dispositivos para consultarlos en cualquier momento, incluso sin internet.'
  }, {
    question: '¿Los patrones están en español?',
    answer: 'Sí, todos los patrones y guías de la biblioteca están completamente en español, con términos claros y fáciles de seguir para que no tengas ninguna duda al tejer.'
  }, {
    question: '¿Puedo imprimir los archivos PDF?',
    answer: '¡Absolutamente! Los archivos están optimizados en alta resolución para que puedas imprimirlos en casa o en una gráfica y tener tus patrones físicamente en tu rincón de tejido.'
  }, {
    question: '¿Necesito ser experta para usar estos patrones?',
    answer: 'Para nada. La biblioteca incluye desde proyectos muy simples para quienes recién comienzan hasta diseños complejos para tejedoras avanzadas. Cada patrón incluye gráficos y explicaciones detalladas paso a paso.'
  }, {
    question: '¿Qué es Alma Textil?',
    answer: 'Alma Textil es nuestro programa especializado en costura y creación textil. Es el complemento perfecto para el crochet, donde aprenderás desde el manejo de la máquina de coser hasta la creación de prendas y accesorios para el hogar con acabados profesionales.'
  }, {
    question: '¿Qué recibo al adquirir el pack completo Hilos que Enamoran + Alma Textil?',
    answer: 'Al elegir la Oferta Completa, recibís acceso de por vida a AMBAS bibliotecas: todos los patrones de crochet de Hilos que Enamoran y todos los módulos de costura de Alma Textil. Además, incluimos los 5 bonos exclusivos de crochet y los 4 bonos de costura (Atelier, Hogar, Marca Textil y Costura desde Cero).'
  }];
  return <ScrollReveal data-id="element-144">
      <section className="max-w-3xl mx-auto px-6 mt-[0px] mb-[0px]" data-id="element-145">
        <div className="text-center mb-12" data-id="element-146">
          <h2 className="text-4xl font-bold text-[#2F5233] font-serif mb-4" data-id="element-147">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8D7B6D]" data-id="element-148">
            Todo lo que necesitás saber sobre Hilos que Enamoran
          </p>
        </div>
        <div className="bg-white/60 backdrop-blur-sm rounded-[2.5rem] p-8 border border-[#2F5233]/10 shadow-sm" data-id="element-149">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-150" />)}
        </div>
      </section>
    </ScrollReveal>;
};
const App = () => {
  useEffect(() => {
    const pixelId = '1293858232676625';
    // Inject Meta Pixel script directly
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}
      else{b.head.appendChild(t)}}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const [purchaseMsg, setPurchaseMsg] = useState<string | null>(null);
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [spots, setSpots] = useState(13);
  const [viewers, setViewers] = useState(48);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return next < 30 ? 33 : next > 60 ? 58 : next;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpots(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const showMsg = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)];
      const actions = ['accedió a', 'ingresó a', 'eligió'];
      const action = actions[Math.floor(Math.random() * actions.length)];
      // 70% Acceso Completo, 30% Hilos que Enamoran
      const product = Math.random() < 0.7 ? 'Acceso Completo' : 'Hilos que Enamoran';
      setPurchaseMsg(`🔥 ${name} de ${city} ${action} ${product}`);
      setTimeout(() => {
        setPurchaseMsg(null);
      }, 6000);
    };
    const msgInterval = setInterval(showMsg, 30000);
    // Initial delay for the first message
    const initialTimeout = setTimeout(showMsg, 10000);
    return () => {
      clearInterval(msgInterval);
      clearTimeout(initialTimeout);
    };
  }, []);
  const [titleVisible, setTitleVisible] = useState(true);
  useEffect(() => {
    const titleInterval = setInterval(() => {
      setTitleVisible(false);
      setTimeout(() => setTitleVisible(true), 4000);
    }, 14000);
    return () => clearInterval(titleInterval);
  }, []);
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePurchase = () => {
    window.location.href = COMBO_CHECKOUT_URL;
  };
  const handleUpsellPurchase = (plan: string) => {
    if (plan === 'combo') {
      window.location.href = COMBO_CHECKOUT_URL;
    } else {
      window.location.href = BASIC_CHECKOUT_URL;
    }
  };
  const [showHookButton, setShowHookButton] = useState(true);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    // Show button when in the top part of the page (hook area)
    if (latest < 800) {
      setShowHookButton(true);
    } else {
      setShowHookButton(false);
    }
  });
  return <div className="min-h-screen selection:bg-[#2F5233]/20 selection:text-[#2F5233]" data-id="element-151">
      <StickyHeader onAction={scrollToPurchase} purchaseMsg={purchaseMsg} data-id="element-152" />
      {/* Header Banner */}
      <div className="text-white py-1.5 text-center font-bold px-4 shadow-sm relative z-50 bg-gradient-to-r from-[#9FD9D3] via-[#82c9c1] to-[#9FD9D3] flex items-center justify-center gap-4 min-h-[40px]" data-id="element-153">
        <AnimatePresence mode="wait" data-id="element-154">
          {purchaseMsg ? <motion.div key="msg" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="text-[#2F5233] text-xs font-bold" data-id="element-155">
              {purchaseMsg}
            </motion.div> : <motion.div key="timer" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="flex items-center justify-center gap-4" data-id="element-156">
              <div className="flex items-center gap-2" data-id="element-157">
                <Calendar className="w-3.5 h-3.5 text-[#2F5233]" data-id="element-158" />
                <span className="text-[#2F5233] uppercase tracking-wider text-[10px]" data-id="element-159">
                  OFERTA VÁLIDA SOLO HOY: {today}
                </span>
              </div>
              <div className="h-3 w-px bg-[#2F5233]/20 hidden sm:block" data-id="element-160" />
              <CountdownTimer data-id="element-161" />
            </motion.div>}
        </AnimatePresence>
      </div>

      {/* Hook Image Section */}
      <ScrollReveal data-id="element-162">
        <section className="w-full flex flex-col items-center relative hero-section-no-gap" data-id="element-163">
          <div className="w-full overflow-hidden" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/kTMcgKJ2XWehvgBEEAMTwL/ChatGPT_Image_29_may_2026,_21_21_37.webp" alt="Aprende Crochet desde Cero" className="w-full h-auto text-[12px] pt-[0px]" data-id="element-165" />
          </div>

          <div className="absolute bottom-12 left-0 right-0 flex justify-center px-6 pointer-events-none" data-id="element-166">
            <button onClick={scrollToPurchase} className="pointer-events-auto bg-[#E07A5F] text-white font-black py-6 px-12 rounded-full shadow-[0_10px_30px_rgba(224,122,95,0.4)] hover:bg-[#D1694E] active:scale-95 transition-all flex uppercase animate-slow-pulse border-2 border-white/20 gap-2 text-[12px] pt-[2px] pb-[2px] pl-[6px] pr-[6px] ml-[0px] items-center justify-center" data-id="element-167">
              QUIERO APRENDER <ChevronRight className="w-8 h-8" data-id="element-168" />
            </button>
          </div>
        </section>
      </ScrollReveal>

      {/* Direct Access Section - Delicate CTA */}
      <ScrollReveal data-id="element-169">
        <div className="flex justify-center -mt-12 relative z-20 px-6" data-id="element-170"></div>
      </ScrollReveal>

      <main className="max-w-5xl mx-auto px-6 py-12 pt-0 pb-[48px] pl-[10px] pr-[10px] space-y-[22px]" data-id="element-171">
        {/* Sales Letter */}
        <section className="prose prose-lg max-w-none space-y-12 text-[#4A3F35] leading-relaxed" data-id="element-172">
          <ScrollReveal data-id="element-173">
            <p className="font-bold text-[#2F5233] text-3xl font-serif mt-[22px]" data-id="element-174">
              Querida amante del crochet,
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-175">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-176">
              <div className="space-y-6" data-id="element-177">
                <p data-id="element-178">Entiendo perfectamente esa sensación.</p>
                <p data-id="element-179">
                  Estás sentada en tu lugar favorito, con el ovillo de lana
                  perfecto y la ilusión de empezar un nuevo proyecto. Pasaste
                  horas buscando en internet un diseño que te emocionara y
                  finalmente encontrás un patrón "gratis".
                </p>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/k7MD9rNXk2rd4ka6qtvPBP/quiero_que_una_202604231645.webp" className="rounded-[2.5rem] shadow-xl w-full h-80 object-cover" alt="Textura de lana" data-id="element-180" />
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-181">
            <p className="text-[#E07A5F] font-bold text-4xl font-serif text-center" data-id="element-182">
              Y de repente... el desastre.
            </p>
          </ScrollReveal>

          <ScrollReveal data-id="element-183">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-184">
              <img src="https://cdn.magicpatterns.com/uploads/tBAoGeMvpwhtqzwwJDSXYX/quiero_que_me_202604231650.webp" className="rounded-[2.5rem] shadow-xl w-full h-80 object-cover order-2 md:order-1" alt="Frustración con el tejido" data-id="element-185" />
              <div className="space-y-6 order-1 md:order-2" data-id="element-186">
                <p data-id="element-187">
                  Llegás a la mitad del camino y los puntos no coinciden. El
                  patrón dice una cosa, pero lo que tenés en las manos es un
                  desorden sin forma. Intentás arreglarlo, pero queda deforme.
                </p>
                <p data-id="element-188">
                  Con dolor en el alma, tenés que desarmar. Tirás del hilo y
                  sentís que con cada punto que deshaces, se te va un pedacito
                  de tu tiempo y de tu ilusión.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-189">
            <div className="my-16 text-center" data-id="element-190">
              <button onClick={scrollToPurchase} className="w-full max-w-2xl bg-[#E07A5F] text-white text-xl md:text-2xl font-black py-8 rounded-[2rem] shadow-xl hover:bg-[#D1694E] active:scale-[0.98] transition-all flex items-center justify-center gap-3 uppercase animate-slow-pulse" data-id="element-191">
                SÍ, QUIERO APRENDER
              </button>
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-192">
            <div className="space-y-12" data-id="element-193">
              <h3 className="text-4xl md:text-5xl font-bold text-[#2F5233] text-center font-serif" data-id="element-194">
                QUÉ VAS A LOGRAR EN HILOS QUE ENAMORAN
              </h3>

              <div className="grid md:grid-cols-2 gap-8" data-id="element-195">
                {[{
                title: 'Aprende Crochet y Dos Agujas desde cero',
                desc: 'Aunque hoy sientas que no sabes por dónde empezar, aquí aprenderás las bases reales del crochet y las dos agujas paso a paso. Desde tus primeros puntos hasta técnicas esenciales para avanzar con seguridad, sin experiencia previa y sin frustrarte.',
                img: 'https://cdn.magicpatterns.com/uploads/aaqbgXLbYk9BoQbAcUcgV8/1.webp'
              }, {
                title: 'Entiende patrones sin frustrarte',
                desc: 'Deja de ver símbolos y patrones como algo complicado. Aprenderás a leer, interpretar y seguir instrucciones con claridad para avanzar con confianza, terminar proyectos y disfrutar el proceso sin sentirte perdida.',
                img: 'https://cdn.magicpatterns.com/uploads/d5dX42yUqsKfqocGzUPNFB/2.webp'
              }, {
                title: 'Crea amigurumis, ropa y proyectos reales',
                desc: 'No solo aprenderás teoría… aprenderás a crear. Descubre cómo transformar hilo en piezas hermosas como amigurumis, ropa, accesorios y proyectos reales que podrás disfrutar, regalar o incluso convertir en una oportunidad.',
                img: 'https://cdn.magicpatterns.com/uploads/7HivzSCi5zMJiBC7X15ju5/3.webp'
              }, {
                title: 'Mejora tu técnica y logra acabados profesionales',
                desc: 'La diferencia está en los detalles. Perfecciona tu técnica, mejora tus puntos, logra tensión uniforme y crea terminaciones prolijas para que cada proyecto se vea más profesional, cuidado y verdaderamente especial.',
                img: 'https://cdn.magicpatterns.com/uploads/9zA1gRM2SnU8iCTKW9FaQK/4.webp'
              }].map((item, idx) => <motion.div key={idx} whileHover={{
                y: -10
              }} className="bg-white/40 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10 shadow-sm overflow-hidden flex flex-col" data-id="element-196">
                    <div className="p-4" data-id="element-197">
                      <img src={item.img} alt={item.title} className="w-full h-auto rounded-[2rem] shadow-md" data-id="element-198" />
                    </div>
                    <div className="p-8 pt-4 space-y-4" data-id="element-199">
                      <h4 className="text-2xl font-bold text-[#2F5233] font-serif leading-tight" data-id="element-200">
                        {item.title}
                      </h4>
                      <p className="text-[#4A3F35] leading-relaxed" data-id="element-201">
                        {item.desc}
                      </p>
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </ScrollReveal>
        </section>

        {/* Project Carousel */}
        <ScrollReveal data-id="element-202">
          <ProjectCarousel data-id="element-203" />
        </ScrollReveal>

        {/* Motivational Section */}
        <ScrollReveal data-id="element-204">
          <section className="max-w-4xl mx-auto px-6 py-16 bg-[#2F5233]/5 rounded-[3rem] border border-[#2F5233]/10 text-center space-y-8" data-id="element-205">
            <h3 className="text-3xl md:text-4xl font-bold text-[#2F5233] font-serif leading-tight italic" data-id="element-206">
              "¿Vas a seguir postergando tu sueño o vas a empezar a crear?"
            </h3>
            <p className="text-lg md:text-xl text-[#8D7B6D] leading-relaxed max-w-3xl mx-auto" data-id="element-207">
              No dejes que tu talento se oxide por miedo a equivocarte o por
              culpa de tutoriales confusos. Recupera tu confianza, domina el{' '}
              <strong data-id="element-208">arte del crochet</strong> y construye un futuro creativo
              desde la comodidad de tu hogar.
            </p>
            <div className="pt-4" data-id="element-209">
              <button onClick={scrollToPurchase} className="bg-[#E07A5F] text-white font-black py-4 px-10 rounded-full shadow-lg hover:bg-[#D1694E] transition-all active:scale-95 uppercase tracking-widest text-sm" data-id="element-210">
                Empezar hoy mismo
              </button>
            </div>
          </section>
        </ScrollReveal>

        {/* Bonuses Section */}
        <section className="mt-32" data-id="element-211">
          <ScrollReveal data-id="element-212">
            <div className="text-center mb-16" data-id="element-213">
              <h3 className="text-4xl md:text-6xl font-black mb-6 text-[#2F5233] pt-[22px] pb-[22px]" data-id="element-214">
                Y SI TE UNÍS AHORA, RECIBÍS ESTOS{' '}
                <span className="text-[#E07A5F]" data-id="element-215">5 BONOS EXCLUSIVOS</span>:
              </h3>
              <p className="text-[#E07A5F] font-bold text-2xl animate-pulse" data-id="element-216">
                ¡GRATIS SOLO POR EL DÍA DE HOY!
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-217">
            {BONUSES.map((bonus, idx) => <ScrollReveal key={bonus.id} delay={idx * 0.1} data-id="element-218">
                <div className="bg-white/60 rounded-[3rem] overflow-hidden border border-[#2F5233]/10 hover:border-[#2F5233]/30 transition-all group cursor-pointer shadow-sm hover:shadow-xl" onClick={handlePurchase} data-id="element-219">
                  <div className="aspect-[4/3] overflow-hidden p-4" data-id="element-220">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-[2rem] border-4 border-white shadow-md group-hover:scale-105 transition-transform duration-1000 pl-[15px] pr-[15px]" data-id="element-221" />
                  </div>
                  <div className="p-8 pt-2" data-id="element-222">
                    <h4 className="text-xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-223">
                      {bonus.title}
                    </h4>
                    <p className="text-[#8D7B6D] text-base leading-relaxed mb-6" data-id="element-224">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center justify-between pt-6 border-t border-[#2F5233]/5" data-id="element-225">
                      <span className="text-sm font-bold text-[#8D7B6D] line-through" data-id="element-226">
                        VALOR: $7.998 PESOS
                      </span>
                      <span className="text-xl font-bold text-[#E07A5F]" data-id="element-227">
                        HOY GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </section>

        {/* Summary Section: What you get */}
        <ScrollReveal data-id="element-228"></ScrollReveal>

        {/* Pricing Section */}
        <ScrollReveal data-id="element-229">
          <div className="text-center mb-16" data-id="element-230"></div>
        </ScrollReveal>

        {/* Final CTA Section */}
        <ScrollReveal data-id="element-231">
          <section id="purchase" className="py-12 px-6 bg-gradient-to-b from-white to-[#FEFDF5] rounded-[4rem] border border-[#2F5233]/10 shadow-2xl relative overflow-hidden pt-[20px] pb-[40px]" data-id="element-232">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#E07A5F]/30 to-transparent" data-id="element-233" />

            <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-234">
              <div className="inline-flex items-center gap-2 bg-[#E07A5F]/10 px-6 py-2 rounded-full mb-8 border border-[#E07A5F]/20" data-id="element-235">
                <Ticket className="w-4 h-4 text-[#E07A5F]" data-id="element-236" />
                <span className="text-[#E07A5F] font-black uppercase tracking-widest text-xs" data-id="element-237">
                  ÚLTIMOS CUPOS DISPONIBLES
                </span>
              </div>

              <h2 className="md:text-6xl font-bold mb-8 text-[#2F5233] font-serif text-[36px]" data-id="element-238">
                ¿Estás lista para transformar tu pasión?
              </h2>

              <p className="text-[#8D7B6D] mb-12 max-w-2xl mx-auto text-[18px]" data-id="element-239">
                No dejes pasar esta oportunidad única de acceder a toda nuestra
                biblioteca de patrones y bonos exclusivos con un descuento
                irrepetible.
              </p>

              <UpsellSection onPurchase={handleUpsellPurchase} data-id="element-240" />

              <div className="flex flex-wrap items-center justify-center gap-8 mt-12 text-[#8D7B6D] text-[36px]" data-id="element-241">
                <div className="flex items-center gap-2 text-[18px]" data-id="element-242">
                  <div className="w-10 h-10 bg-[#E07A5F]/10 rounded-full flex items-center justify-center" data-id="element-243">
                    <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-244" />
                  </div>
                  <span className="text-sm font-bold text-[#E07A5F]" data-id="element-245">
                    100% de satisfacción garantizada
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-246">
                  <div className="w-10 h-10 bg-[#E07A5F]/10 rounded-full flex items-center justify-center" data-id="element-247">
                    <InfinityIcon className="w-5 h-5 text-[#E07A5F]" data-id="element-248" />
                  </div>
                  <span className="text-sm font-bold text-[#E07A5F]" data-id="element-249">
                    Acceso de por vida
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-250">
                  <div className="w-10 h-10 bg-[#E07A5F]/10 rounded-full flex items-center justify-center" data-id="element-251">
                    <Heart className="w-5 h-5 text-[#E07A5F]" data-id="element-252" />
                  </div>
                  <span className="text-sm font-bold text-[#E07A5F]" data-id="element-253">
                    Comunidad de expertos
                  </span>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        <FAQSection data-id="element-254" />

        <CommentSection data-id="element-255" />
      </main>

      <footer className="bg-white/20 py-24 border-t border-[#2F5233]/10 text-center text-[#8D7B6D] text-lg" data-id="element-256">
        <ScrollReveal data-id="element-257">
          <p className="mb-4" data-id="element-258">
            © {new Date().getFullYear()} Hilos que Enamoran. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-60" data-id="element-259">
            Este sitio no es parte de Facebook ni de Google Inc.
          </p>
        </ScrollReveal>
      </footer>
    </div>;
};
export { App };